import DraggableThumb from '../draggable_thumb_controller';

export default class extends DraggableThumb {
  static targets = ['imageIndexField', 'image'];

  static values = {
    kind: String,
    tab: String,
    imageIds: String,
    imageId: String,
  };

  createGhostElement() {
    const element = document.createElement('img');
    const imageIndex = parseInt(this.imageIndexFieldTarget.value) || 0;
    element.src = this.imageTargets[imageIndex].src;

    return element;
  }

  addItem(itemProps) {
    const actions = {
      library: 'library_item_added_to_canvas',
      project_items: 'project_items_item_added_to_canvas',
      product: 'product_added_to_canvas',
    };
    const action = actions[this.tabValue];
    if (action) {
      window.ed.featureActionsService.add(action);
    }

    itemProps['kind'] = this.kindValue;

    if (this.imageIdsValue !== '') {
      itemProps['imageIds'] = this.imageIdsValue;
    }

    if (this.imageIdValue !== '') {
      itemProps['imageId'] = this.imageIdValue;
    }

    return super.addItem(itemProps);
  }

  onThumbPictureChanged(event) {
    this.imageIdsValue = event.detail.imageIds;
    this.imageIdValue = event.detail.imageId;
    this.imageIndexFieldTarget.value = event.detail.index;
  }
}
